import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { MediaService } from './media.service';

@Injectable({
  providedIn: 'root'
})
export class VormingService {

  constructor(private http:HttpClient, private mediaService:MediaService) { }

  getVormingen() {
    return this.http.get<any>(`${environment.apiBaseUrl}/vormingen?populate=*`);
  }

  getVorming(id:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/vormingen?filters[id][$eq]=${id}&populate=*`);
  }

  populateVorming(data:any) {
    let vorming = data;
    vorming.id = data.id;
    let d = new Date(Date.parse(vorming.tijdstip));
    const optionsDate:any = { year: 'numeric', month: 'long', day: 'numeric' };
    const optionsTime:any = { hour: '2-digit', minute: '2-digit' };
    vorming.hour = d.toLocaleTimeString('nl-BE', optionsTime);
    vorming.date = d.toLocaleDateString('nl-BE', optionsDate);
    vorming.foto = this.mediaService.getMediaItemUrl(vorming.foto);
    vorming.poster = this.mediaService.getMediaItemUrl(vorming.poster, null);

    return vorming;
  }
}
